import MagstimTable from './MagstimTable';

import { CurrentLang } from 'common';
import routeManager from 'RouteManager';

import './MagstimTableClinicalAssessments.css'

class MagstimTableClinicalAssessments extends MagstimTable {


	initForSelect = (data, heightPx) => {
		// console.log(`MagstimTablePatient.initForSelect(${JSON.stringify(data)}, ${heightPx})`);
		this.initTable(this.configTableData(data), heightPx);
	}

	initForEdit = (data, heightPx) => {
		this.initTable(this.configTableData(data), heightPx);
	}

	configTableData(data) {

		var columns =  [
			{ title: CurrentLang().clinical_assessment_assessment_date, property: 'AssessmentDate', formatter: this.formatUtcDate },	
			{ title: CurrentLang().clinical_assessment_rating_scale, property: 'RatingScale' },
			{ title: CurrentLang().clinical_assessment_rating_score, property: 'RatingScore' },
			{ title: CurrentLang().clinical_assessment_assessed_by, property: 'ResolvedAssessedBy'}	
		]

		if(routeManager.isOrganisationAdmin === true){
			columns.push(	{ title: '', property: 'delete', sortable: false, groupedColumn: true, formatter: this.formatEdit })
		}

		return {
			columns: columns,
			data: data
		};
    }
    
    resetFilters() {
		// console.log('MagstimTablePatient.resetFilters');
		super.resetFilters();
		this.addFilter('Type', '');
		this.addFilter('RatingScale', '');
	}

	formatEdit(value, column, row) {
        
        //console.log('', value, column, row);
        const elemCheck = document.createElement('i');
        elemCheck.className = 'fas fas fa-trash-alt';
        elemCheck.style.color = '#FFFFFF';
        return elemCheck;
    }

    columnsTableTreatmentTemplateEdit() {
        var retVal = this.columnsTableTreatmentTemplateSelect();
        retVal.push({ title: '', property: 'mode', sortable: false, groupedColumn: true, formatter: this.formatEdit });
        return retVal;
    }
}


export default MagstimTableClinicalAssessments;